export default "__VITE_ASSET__DoVXGqvY__"